var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sideBar',{attrs:{"filters_prop":_vm.custom_filter,"loading":_vm.loadingFilter},on:{"refilter":_vm.setFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }